import UserStore from 'stores/root/UserStore';
import SampleStore from 'stores/root/SampleStore';
import ClsDataStore from 'stores/shared/ClsDataStore';

import PageStore from './PageStore';
import { RootStoreT } from 'types/frontend/RootStore';
import TeacherListCommonStore from 'stores/TeacherListCommonStore';
import StudentListDataStore from 'stores/shared/StudentListDataStore';

export const updateVersion = (
  version: 'studentList' | 'teacherList' | 'clsList' | 'myInfo',
) => {
  switch (version) {
    case 'studentList':
      rootStore.studentListDataStore.setVersion(new Date().toString());
      break;
    case 'teacherList':
      if (rootStore.stores.TeacherListCommonStore) {
        (
          rootStore.stores.TeacherListCommonStore as TeacherListCommonStore
        ).setVersion(new Date().toString());
      }
      break;
    case 'clsList':
      rootStore.clsDataStore.setVersion(new Date().toString());
      break;
    case 'myInfo':
      rootStore.userStore.setVersion(new Date().toString());
  }
};

export const initClsDataStore = (name?: string) => {
  rootStore.clsDataStore.init(name);
};

export const getActiveAcademyId = () => {
  return rootStore.pageStore.activeAcademyId;
};

export const getActiveAcademySetting = () => {
  return rootStore.userStore.activeAcademySetting;
};

const clsDataStore = new ClsDataStore();

export const rootStore: RootStoreT = {
  userStore: new UserStore(),
  sampleStore: new SampleStore(),
  clsDataStore,
  studentListDataStore: new StudentListDataStore(clsDataStore),
  pageStore: new PageStore(),
  stores: {},
};
